const d = ["#dcd2ee", "#a995cd", "#826bab", "#2e0f57"], e = ["#dcd2ee", "#bbadd4", "#9581b7", "#6d5598", "#2e0f57"], P = [
  "#f2f0f6",
  "#dcd2ee",
  "#baa8dc",
  "#9781be",
  "#6d5598",
  "#2e0f57"
];
export {
  d as DEMOGRAPHICS_PURPLE_4,
  e as DEMOGRAPHICS_PURPLE_5,
  P as DEMOGRAPHICS_PURPLE_6
};
//# sourceMappingURL=index.es5686.js.map
